import { Link, useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../api';
import { useSession } from '../../session';
import type { FulfilmentView } from '../../types';
import { ErrorBox, Loading, dt } from '../../ui';
import { FulfilmentCard } from '../buyer/Indents';

/** Supplies recorded during an outage have no indent, so they need their own review page. */
export function SupplyDetail() {
  const { id } = useParams();
  const { can } = useSession();
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ['fulfilment', id], queryFn: () => api.get<FulfilmentView>(`/api/fulfilments/${id}`) });
  if (q.isLoading) return <Loading />;
  if (q.error) return <ErrorBox error={q.error} />;
  const f = q.data!;
  return (
    <div className="stack">
      <h1>Supply {f.number}</h1>
      {f.manual ? (
        <div className="card summary">
          <h2>Manual supply record</h2>
          <p>This supply was recorded after the event. Company accounts can check the paper slip and accept it for the company.</p>
          <dl>
            <dt>Slip / bill number</dt><dd>{f.manual.sourceReference}</dd>
            <dt>Reason</dt><dd>{f.manual.reason}</dd>
            <dt>Recorded at</dt><dd>{dt(f.recordedAt)}</dd>
            {f.person ? <><dt>Driver</dt><dd>{f.person.name}</dd></> : null}
            {f.vehicle ? <><dt>Vehicle</dt><dd>{f.vehicle.registrationNumber}</dd></> : null}
          </dl>
          {f.manual.aboveLimit ? <div className="alert warn">This supply took the account above its credit limit.</div> : null}
        </div>
      ) : null}
      <FulfilmentCard f={f} canAccountsAck={can('ack.accounts')} canDispute={can('buyer.disputes.raise')} onChanged={() => void qc.invalidateQueries()} />
      <Link to="/notifications">Back to notifications</Link>
    </div>
  );
}
